import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","CookiePolicyDataId"] */ "/codebuild/output/src2012239524/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
